module.exports = __webpack_public_path__ + "static/media/guest.a2b1f548.svg";